import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import {
  ADD_NEW_COORDINATION,
  DELETE_COORDINATION,
  GET_COORDINATIONS,
  UPDATE_COORDINATION,
  UPDATE_COORDINATION_STATUS
} from "./actionTypes";

import {
  addCoordinationFail,
  addCoordinationSuccess,
  deleteCoordinationFail,
  deleteCoordinationSuccess,
  getCoordinationsFail,
  getCoordinationsSuccess,
  setState,
  updateCoordinationFail,
  updateCoordinationSuccess,
} from "./actions";

import { toast } from 'react-toastify';
import { coordinations, updateStatus } from '../../../helpers/adipiBackendUrl';
import { deleteApiCall, getTable, patchApiCall, postApiCall } from "../../../services/mainServices";

function* fetchCoordinations({ payload: { params } }) {
  try {
    yield put(setState(true));
    const response = yield call(getTable, coordinations, params.toString());
    yield put(setState(false));
    yield put(getCoordinationsSuccess(response.items, response.totalPages, response.currentPage));
  } catch (error) {
    yield put(setState(false));
    yield put(getCoordinationsFail(error));
  }
}

function* updateCoordination({ payload: coordinationObj }) {
  try {
    const { id, ...rest } = coordinationObj;
    yield call(patchApiCall, `${coordinations}/${id}`, rest);
    const response = yield call(getTable, `${coordinations}/${coordinationObj.id}`);
    yield put(updateCoordinationSuccess(response));
    toast.success('Registro actualizado correctamente');
  } catch (error) {
    yield put(updateCoordinationFail(error));
    toast.error('Error al actualizar el registro');
  }
}

function* updateCoordinationStatus({ payload: coordinationObj }) {
  try {
    yield call(patchApiCall, `${coordinations}/${updateStatus}/${coordinationObj.id}`, { recordStatus: coordinationObj.recordStatus });
    const response = yield call(getTable, `${coordinations}/${coordinationObj.id}`);
    yield put(updateCoordinationSuccess(response));
  } catch (error) {
    yield put(updateCoordinationFail(error));
  }
}

function* deleteCoordination({ payload: coordinationObj }) {
  try {
    yield call(deleteApiCall, `${coordinations}/${coordinationObj.id}`);
    yield put(deleteCoordinationSuccess(coordinationObj.id));
    toast.success('Registro borrado correctamente');
  } catch (error) {
    yield put(deleteCoordinationFail(error));
    toast.error('Error al borrar el registro');
  }
}

function* postingCoordination({ payload: coordination }) {
  try {
    const response = yield call(postApiCall, coordinations, coordination);
    yield put(addCoordinationSuccess(response));
    toast.success('Registro agregado correctamente');
  } catch (error) {
    yield put(addCoordinationFail(error));
    toast.error('Error al agregar el registro');
  }
}

function* coordinationsSaga() {
  yield takeEvery(GET_COORDINATIONS, fetchCoordinations);
  yield takeEvery(ADD_NEW_COORDINATION, postingCoordination);
  yield takeEvery(UPDATE_COORDINATION, updateCoordination);
  yield takeEvery(UPDATE_COORDINATION_STATUS, updateCoordinationStatus);
  yield takeEvery(DELETE_COORDINATION, deleteCoordination);
}

export default coordinationsSaga;
